import React, { Component } from 'react'
import injectStyles from 'react-jss'
import Button from './../../../../modules/Button'
import classNames from 'classnames'

const styles = {
  cancelButton: {
    position: 'absolute',
    bottom: 56,
    left: 0,
    right: 0,
    cursor: 'pointer',
  },
  cancelButtonDisabled: {
    color: 'grey',
  },
  button: {
    width: 358,
    height: 42,
    boxSizing: 'border-box',
    fontSize: 14,
    padding: 0,
  },
  descriptionInput: {

    paddingLeft: 22,
    paddingRight: 22,
    paddingTop: 10,
    paddingBottom: 10,
    width: '100%',
    height: 60,
    border: '1px solid #BDC3CC',
    borderRadius: 2,
    resize: 'none',
    boxSizing: 'border-box',
  },
  input: {
    width: 358,
    height: 42,
    boxSizing: 'border-box',
    paddingLeft: 22,
    paddingRight: 22,
    fontSize: 14,
    color: '#333333',
  },
  container: {
    '@global label': {
      fontWeight: 'bold',
    },
  },
  newBranchGroup: {
    '@global': {
      '> *': {
        display: 'inline-block',
      }
    },
  },
}

class BranchSave extends Component {

  state = {
    newBranchSelected: false,
  }

  toggleNewBranchSelection = () => this.setState({
    newBranchSelected: !this.state.newBranchSelected,
  })

  onSave = () => {
    const { onSave, onSaveNewBranch } = this.props
    const { newBranchSelected } = this.state
    var newBranchName = this.newBranchInput_ ? this.newBranchInput_.value : ''
    var commitMessage = this.commitMessageInput_.value
    if (newBranchSelected && !newBranchName) return
    if (newBranchName)
      return onSaveNewBranch(newBranchName, commitMessage)
    return onSave(commitMessage)
  }

  render = () => {
    const { saving, onClose, classes } = this.props
    const { newBranchSelected } = this.state
    return <div className={classes.container}>
      <h3>Save Branch</h3>
      <br />
      <div>
        <div className={classes.newBranchGroup}>
          <label>Create new branch?</label>
          <input
            type="checkbox"
            onClick={this.toggleNewBranchSelection}
          />
        </div>
        <br />
        {newBranchSelected ?
          <div>
            <input
              type="text"
              ref={el => this.newBranchInput_ = el}
              className={classes.input}
              placeholder="Name of new branch..."
            />
          </div> :
          null}
      </div>
      <br />
      <div>
        <textarea
          className={classes.descriptionInput}
          ref={el => this.commitMessageInput_ = el}
          placeholder="Commit message..."
        >

        </textarea>
      </div>
      <br />
      <Button
        className={classes.button}
        onClick={this.onSave}
        disabled={saving}
      >
        {saving ? 'Saving...' : 'Save'}
      </Button>
      <div
        className={classNames({
          [classes.cancelButton]: true,
          [classes.cancelButtonDisabled]: saving,
        })}
        onClick={saving ? null : onClose}
      >Cancel</div>
    </div>
  }
}

export default injectStyles(styles)(BranchSave)


// WEBPACK FOOTER //
// ./src/pages/RepositoryEdit/SaveBranchDialog/BranchSave/BranchSave.js